{
    "coordinates": [
        24.882216494589144,
        109.70312701807029
    ],
    "tooltip": "Gigantopithecus Fauna",
    "title": "Gigantopithecus Fauna",
    "country": "China",
    "period": "Neogene",
    "alt": "TODO"
}
